import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import sr from './locales/sr.json';
import sk from './locales/sk.json';
import hu from './locales/hu.json';

const resources = {
  en: {
    translation: en,
  },
  sr: {
    translation: sr,
  },
  sk: {
    translation: sk,
  },
  hu: {
    translation: hu,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n; 